import { createSelector } from 'reselect'

export const getPackageCategoriesLoading = createSelector(
  state => state && state.user && state.user.packages && state.user.packages.packageCategories
    ? state.user.packages.packageCategories.isLoading : false,
  isLoading => isLoading
)
